import styled from 'styled-components';
import { ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import RegisterStatusLimitTable from './RegisterStatusLimitTable';
import { useEffect, useState } from 'react';
import { uesrGradeType } from '../../../../utils/auth';
// import NoDataMessage from '../../components/NoData';

interface ListProps {
  etc: string;
  extinctYN: string;
  holder: string;
  lamount: string;
  regDate: string;
  relation: string;
  rno: string;
  rtype: string;
}

interface RegisterStatusProps {
  landInfo: [
    {
      totalAmount: number;
    },
    {
      list: ListProps[];
    },
  ];
  buildingInfo: [
    {
      totalAmount: number;
    },
    {
      list: ListProps[];
    },
  ];
  registerNote: string[];
  anotherInfo: [
    {
      totalAmount: number;
    },
    {
      list: ListProps[];
    },
  ];
  isExample?: boolean;
}

const PRegisterStatus = ({ registerStatus, warning, isExample }: any) => {
  const [userGrade, setUserGrade] = useState<string | null>(null);

  useEffect(() => {
    if (isExample) return;
    const fetchUserGrade = async () => {
      try {
        const grade = await uesrGradeType();
        setUserGrade(grade);
      } catch (error) {
        console.error('유저 등급 정보 가져오기 실패:', error);
      }
    };

    fetchUserGrade();
  }, []);
  const newData = JSON.parse(registerStatus);
  console.log('newData', newData);
  return (
    <Container id="등기부현황">
      <Title>
        <span>등기부 현황</span>
      </Title>
      <ContentItemTitle>
        <img src="/assets/images/icon/icon_registerStatus.svg"></img>
        등기부
      </ContentItemTitle>
      {!isExample && !userGrade ? (
        <div style={{ marginBottom: '60px' }}>
          <RegisterStatusLimitTable />
        </div>
      ) : (
        <Content>
          <DataWrapper>
            <table style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <TableHeadTh width={'25%'}>
                    번호/
                    <br />
                    설정일자
                  </TableHeadTh>
                  <TableHeadTh width={'25%'}>
                    권리종류/<br></br>권리자명
                  </TableHeadTh>
                  <TableHeadTh width={'25%'}>설정금액(원)</TableHeadTh>
                  <TableHeadTh width={'25%'}>비고</TableHeadTh>
                </tr>
              </thead>
              <tbody style={{ width: '100%' }}>
                {newData.slice(1).map((data: any, index: number) => (
                  <TableRowWrapper text={data[1]} key={index}>
                    <TablebodyTd width={'25%'}>
                      {data[0]}/<br></br>
                      {data[3]}
                    </TablebodyTd>
                    <TablebodyTd width={'25%'}>
                      {data[1]}/
                      <br />
                      {data[2]}
                    </TablebodyTd>
                    <TablebodyTd
                      width={'25%'}
                      style={{
                        color:
                          data[1] && data[1].includes('청구금액')
                            ? '#008AFF'
                            : '#171e26',
                        fontWeight:
                          data[1] && data[1].includes('청구금액') ? 700 : 500,
                      }}
                    >
                      {data[4]}
                    </TablebodyTd>
                    <TablebodyTd width={'25%'}>-</TablebodyTd>
                  </TableRowWrapper>
                ))}
                {newData.length === 0 && Nodata()}
              </tbody>
            </table>
          </DataWrapper>
        </Content>
      )}
      {(isExample || userGrade) &&
        newData &&
        newData.length > 1 &&
        newData[1] && (
          <YellowBox>
            <img src="/assets/images/icon/warning.svg" alt="" />
            <div>
              본 정보는 공사에 공매의뢰된 시점의 정보로 현행 등기사항증명서과
              다를 수 있으며, 일부 정보의 표시가 누락, 오기될 수 있습니다. 또한,
              아래 순번은 등기사항증명서 순위번호와 무관하며, 이해관계자별 2개
              이상의 권리내용이 있는 경우 편의상 그 내용을 하나의 권리로 표시한
              경우도 있습니다. 따라서 본 정보는 참고용 자료로만 활용하시고
              정확한 정보 확인을 위해서는 반드시 등기사항증명서 관련 공부를
              확인하시기 바랍니다.
            </div>
          </YellowBox>
        )}
    </Container>
  );
};

export default PRegisterStatus;

export const RegisterStatus = ({
  landInfo,
  buildingInfo,
  registerNote,
  anotherInfo,
  isExample,
}: RegisterStatusProps) => {
  const [userGrade, setUserGrade] = useState<string | null>(null);

  useEffect(() => {
    if (isExample) return;
    const fetchUserGrade = async () => {
      try {
        const grade = await uesrGradeType();
        setUserGrade(grade);
      } catch (error) {
        console.error('유저 등급 정보 가져오기 실패:', error);
      }
    };

    fetchUserGrade();
  }, []);

  const { itemType } = useReportContext();

  /** 등기부 데이터 유효성 검사*/
  const isValidData = (data: string): boolean => {
    return /^\((갑|을)\d+\)$/.test(data);
  };

  const convertData = (data: any) => {
    if (data && typeof data === 'string' && data.includes('청구금액')) {
      let temp = data.split(':');
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {temp[0]}:
          <span style={{ color: '#008AFF', fontWeight: 700 }}>{temp[1]}</span>
        </div>
      );
    } else {
      return data || '';
    }
  };
  return (
    <Container id="등기부현황">
      <Title>
        <span>등기부 현황</span>
      </Title>
      {/* Todo: 지역 멤버십 연결 */}
      {/* <ContentItem>
        <ContentItemTitle>
          <img src="/assets/images/icon/icon_registerStatus.svg"></img>
          등기부
        </ContentItemTitle>
        <div style={{ marginBottom: '60px' }}>
          <RegisterStatusLimitTable isRegion />
        </div>
      </ContentItem> */}

      {!isExample && !userGrade ? (
        <ContentItem>
          <ContentItemTitle>
            <img src="/assets/images/icon/icon_registerStatus.svg"></img>
            등기부
          </ContentItemTitle>
          <div style={{ marginBottom: '60px' }}>
            <RegisterStatusLimitTable />
          </div>
        </ContentItem>
      ) : (
        <>
          <Content>
            {landInfo &&
            landInfo[1] &&
            landInfo[1].list &&
            landInfo[1].list.length > 0 ? (
              <ContentItem>
                <ContentItemTitle>
                  <img src="/assets/images/icon/icon_registerStatus.svg"></img>
                  토지 등기부
                </ContentItemTitle>
                <SingleRowTable>
                  <TableRow>
                    <SingleRowTableHeadCell
                      width="134px"
                      style={{ fontWeight: 500 }}
                    >
                      채권액 합계
                    </SingleRowTableHeadCell>
                    <SingleRowTableBodyCell width="100%">
                      {landInfo[0].totalAmount && landInfo[1].list.length > 100
                        ? ReportFormatNumber(landInfo[0].totalAmount)
                        : '해당내용없음'}
                    </SingleRowTableBodyCell>
                  </TableRow>
                </SingleRowTable>

                <div style={{ borderTop: '1px solid #222222' }}>
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      borderSpacing: '0',
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          // borderCollapse: 'separate', // ✅ 해결
                          // borderTop: ' 1px solid purple ',
                          borderSpacing: '0',
                        }}
                      >
                        <TableHeadTh width={'23%'}>
                          {' '}
                          구분/<br></br>접수일
                        </TableHeadTh>
                        <TableHeadTh width={'23%'}>
                          권리종류/
                          <br />
                          권리자/
                          <br />
                          소멸여부
                        </TableHeadTh>
                        <TableHeadTh width={'27%'}>채권금액</TableHeadTh>
                        <TableHeadTh width={'27%'}>비고</TableHeadTh>
                      </tr>
                    </thead>
                    <tbody>
                      {landInfo[1].list.length > 0
                        ? landInfo[1].list.map(
                            (data, index) =>
                              isValidData(data.relation) && (
                                <TableRowWrapper text={data.etc} key={index}>
                                  <TablebodyTd width={'23%'}>
                                    {index + 1}
                                    {isValidData(data.relation)
                                      ? data.relation
                                      : ''}
                                    <br />
                                    {data.regDate}
                                  </TablebodyTd>
                                  <TablebodyTd width={'23%'}>
                                    {data.rtype}
                                    <br></br>
                                    {data.holder}
                                    <br></br>
                                    {data.extinctYN && `(${data.extinctYN})`}
                                  </TablebodyTd>
                                  <TablebodyTd
                                    width="27%"
                                    style={{ textAlign: 'left' }}
                                  >
                                    {convertData(data.lamount)}
                                  </TablebodyTd>{' '}
                                  <TablebodyTd width="27%">
                                    {data.etc
                                      ? data.etc
                                          .replace('존속기간:', '존속기간:\n')
                                          .replace('~', '~\n')
                                      : ''}
                                  </TablebodyTd>
                                </TableRowWrapper>
                              ),
                          )
                        : Nodata()}
                    </tbody>
                  </table>
                </div>
              </ContentItem>
            ) : (
              ''
            )}
            {/* 건물 일때만  나옴  */}
            {itemType === 'H' &&
            buildingInfo &&
            buildingInfo[1] &&
            buildingInfo[1].list &&
            buildingInfo[1].list.length > 0 ? (
              <ContentItem>
                <ContentItemTitle>
                  <img src="/assets/images/icon/icon_registerStatus.svg"></img>
                  건물등기부
                </ContentItemTitle>
                <SingleRowTable>
                  <TableRow>
                    <SingleRowTableHeadCell
                      width="134px"
                      style={{ fontWeight: 500 }}
                    >
                      채권액 합계
                    </SingleRowTableHeadCell>
                    <SingleRowTableBodyCell width="100%">
                      {ReportFormatNumber(buildingInfo[0].totalAmount)}
                    </SingleRowTableBodyCell>
                  </TableRow>
                </SingleRowTable>
                <div style={{ borderTop: '1px solid #222222' }}>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr>
                        <TableHeadTh width={'23%'}>
                          {' '}
                          구분/<br></br>접수일
                        </TableHeadTh>
                        <TableHeadTh width={'23%'}>
                          권리종류/
                          <br />
                          권리자/
                          <br />
                          소멸여부
                        </TableHeadTh>
                        <TableHeadTh width={'27%'}>채권금액</TableHeadTh>
                        <TableHeadTh width={'27%'}>비고</TableHeadTh>
                      </tr>
                    </thead>
                    <tbody>
                      {buildingInfo[1].list.length > 0
                        ? buildingInfo[1].list.map(
                            (data, index) =>
                              isValidData(data.relation) && (
                                <TableRowWrapper text={data.etc} key={index}>
                                  <TablebodyTd width={'23%'}>
                                    {index + 1}
                                    {isValidData(data.relation)
                                      ? data.relation
                                      : ''}
                                    <br />
                                    {data.regDate}
                                  </TablebodyTd>
                                  <TablebodyTd width={'23%'}>
                                    {data.rtype}
                                    <br></br>
                                    {data.holder}
                                    <br></br>
                                    {data.extinctYN && `(${data.extinctYN})`}
                                  </TablebodyTd>
                                  <TablebodyTd
                                    width="27%"
                                    style={{
                                      wordBreak: 'keep-all',
                                      textAlign: 'left',
                                    }}
                                  >
                                    {convertData(data.lamount)}
                                  </TablebodyTd>{' '}
                                  <TablebodyTd width="27%">
                                    {data.etc
                                      ? data.etc
                                          .replace('존속기간:', '존속기간:\n')
                                          .replace('~', '~\n')
                                      : ''}
                                  </TablebodyTd>
                                </TableRowWrapper>
                              ),
                          )
                        : Nodata()}
                    </tbody>
                  </table>
                </div>
              </ContentItem>
            ) : (
              ''
            )}

            {anotherInfo &&
            anotherInfo[1] &&
            anotherInfo[1].list &&
            anotherInfo[1].list.length > 0 ? (
              <ContentItem>
                <ContentItemTitle>
                  <img src="/assets/images/icon/icon_registerStatus.svg"></img>
                  등기부
                </ContentItemTitle>
                <SingleRowTable>
                  <TableRow>
                    <SingleRowTableHeadCell
                      width="134px"
                      style={{ fontWeight: 500 }}
                    >
                      채권액 합계
                    </SingleRowTableHeadCell>
                    <SingleRowTableBodyCell width="100%">
                      {ReportFormatNumber(anotherInfo[0].totalAmount)}
                    </SingleRowTableBodyCell>
                  </TableRow>
                </SingleRowTable>
                <div style={{ borderTop: '1px solid #222222' }}>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr>
                        <TableHeadTh width={'23%'}>
                          {' '}
                          구분/<br></br>접수일
                        </TableHeadTh>
                        <TableHeadTh width={'23%'}>
                          권리종류/
                          <br />
                          권리자/
                          <br />
                          소멸여부
                        </TableHeadTh>
                        <TableHeadTh width={'27%'}>채권금액</TableHeadTh>
                        <TableHeadTh width={'27%'}>비고</TableHeadTh>
                      </tr>
                    </thead>
                    <tbody>
                      {anotherInfo[1].list.length > 1 &&
                        anotherInfo[1].list.map(
                          (data, index) =>
                            isValidData(data.relation) && (
                              <TableRowWrapper text={data.etc} key={index}>
                                <TablebodyTd width={'23%'}>
                                  {index + 1}
                                  {isValidData(data.relation)
                                    ? data.relation
                                    : ''}
                                  <br />
                                  {data.regDate}
                                </TablebodyTd>
                                <TablebodyTd width={'23%'}>
                                  {data.rtype}
                                  <br></br>
                                  {data.holder}
                                  <br></br>
                                  {data.extinctYN && `(${data.extinctYN})`}
                                </TablebodyTd>
                                <TablebodyTd
                                  width="27%"
                                  style={{ textAlign: 'left' }}
                                >
                                  {convertData(data.lamount)}
                                </TablebodyTd>{' '}
                                <TablebodyTd width="27%">
                                  {data.etc
                                    ? data.etc
                                        .replace('존속기간:', '존속기간:\n')
                                        .replace('~', '~\n')
                                    : ''}
                                </TablebodyTd>
                              </TableRowWrapper>
                            ),
                        )}
                      {anotherInfo[1].list.length === 0 && Nodata()}
                    </tbody>
                  </table>
                </div>
              </ContentItem>
            ) : (
              ''
            )}
          </Content>
          {itemType === 'H' && registerNote.length > 1 && (
            <YellowBox>
              <img src="/assets/images/icon/warning.svg" alt="" />
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
              >
                <div style={{ fontWeight: 700, fontSize: 18 }}>주의사항</div>
                {registerNote.map((item, index) => (
                  <div key={index}>{item === '' ? '-' : String(item)}</div>
                ))}
              </div>
            </YellowBox>
          )}
        </>
      )}
    </Container>
  );
};

function Nodata() {
  return (
    <TableRowWrapper text="">
      <TablebodyTd width="100%" colSpan={4}>
        해당내용없음
      </TablebodyTd>
    </TableRowWrapper>
  );
}

const DataWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #222222;
`;

interface WidthProps {
  width: string;
}

interface TableRowWrapperProps {
  text: string;
}

const TableRowWrapper = styled.tr<TableRowWrapperProps>`
  background-color: ${({ text }) =>
    text && text.includes('말소기준등기') ? '#FFF1F0' : 'none'};

  td,
  th {
    color: ${({ text }) =>
      text && text.includes('말소기준등기') ? '#FA4032' : '#171e26'};
    font-weight: ${({ text }) =>
      text && text.includes('말소기준등기') ? '700' : '500'};
  }

  border-bottom: 1px solid #e1e2e4;
  // &:last-child {
  //   border-bottom: none;
  // }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: white;
  padding: 32px 16px;
`;

const Title = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 31.9px */
  letter-spacing: -0.44px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-end;
`;
const Description = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ContentItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentItemTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.2px;
  letter-spacing: -0.36px;
  color: #222222;
  display: flex;
  gap: 4px;
  align-items: center;
`;
const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 4px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;

  border-right: 1px solid #e8e9ea; /* 기본적으로 border-right 적용 */

  &:nth-last-of-type(1) {
    border-right: none; /* 마지막 요소일 경우 border-right 제거 */
  }
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px; /* 23.2px */
  letter-spacing: -0.32px;
  color: #171e26;
  word-break: break-word;

  border-right: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;

const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const SingleRowTableHeadCell = styled.div<WidthProps>`
  width: 100%;
  text-align: center;
  border-top: 1px solid #222;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-bottom: 1px solid #e1e2e4;
  padding: 6px 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;
`;
const YellowBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(250, 177, 47, 0.1);
  border-radius: 8px;
  padding: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #a86c00;
`;
